const Data = [
    {
        name: "Nirmal Kumawat",
        position: "UG Coordinator",
        imageUrl: "/images/profile.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Pranay Harwani",
        position: "UG Coordinator",
        imageUrl: "/assets/images/members/Pranay Harwani.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    }
]

export default Data;